<template>
  <div
    class="d-flex flex-column "
    :class="isMobile ? 'ga-4' : 'ga-6 pa-6 elevation-1 rounded-sm'"
  >
    <div class="text-h6 text--text">
      {{ title }}
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ContextStore } from 'src/components/pages/info/ethical-commission/index/types'
import { useContextStore } from 'src/store'

defineProps<{
  title: string
}>()

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
</script>
